import axios from "axios";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { IHeadersProps } from "../recoil/userInfoAtom";

// 댓글 쓰기
interface IPostProps {
  postApi: string;
  postValue: any;
  headers: IHeadersProps;
}

const postData = async (props: IPostProps) => {
  const { postApi, postValue, headers } = props;
  let res = await axios.post(postApi, postValue, {
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });

  return res;
};

export const usePostContentsMutation = (type: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(postData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries([type]);
        // alert(t("Comment_writing_is_complete"));
      }
    },
    onError: (error) => {
      // console.log(error, "Post Mutation error");
    }
  });
};

// 이전 댓글 내용 보기
interface getBeforeCommentProps {
  headers: IHeadersProps;
  getApi: string;
}

export const getBeforeComment = async (props: getBeforeCommentProps) => {
  const { headers, getApi } = props;

  const { data } = await axios.get(getApi, { headers: { ...headers } });
  return data;
};

// 댓글 수정하기
interface IPutProps {
  postValue: any;
  headers: IHeadersProps;
  putApi: string;
}
const putData = async (props: IPutProps) => {
  const { putApi, postValue, headers } = props;

  const api = await axios.post(putApi, postValue, {
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });

  return api;
};

export const usePutContentsMutation = (type: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(putData, {
    onSuccess: (api) => {
      if (api.data.result === 1) {
        queryClient.invalidateQueries([type]);
        // alert(t("Comments_have_been_edited"));
      } else {
        alert(t(api?.data.msg));
      }
    },
    onError: (error) => {
      // console.log(error, "Put Mutation error");
    }
  });
};
